import { useContext, useMemo } from 'react';

import GlobalContext from '@/context/GlobalContext';

export const DEFAULT_LABELS: Record<string, string> = {
	description: 'Description',
	outcomes: 'Outcomes',
	resources: 'Resources',
	units: 'Units of Focus',
	lessonPlans: 'Lesson Plans',
	prereq: 'Prerequisites',
	extraInfo: 'Additional Information',
	question: 'Essential Question',
	topic: 'Subtopic/Description',
	skill: 'Skill',
};

export function useTabLabels() {
	const { siteSettings } = useContext(GlobalContext);
	return useMemo(
		() => ({ ...DEFAULT_LABELS, ...siteSettings?.label_config }),
		[siteSettings?.label_config]
	);
}
